module.exports = __webpack_public_path__ + "static/media/Summary.5a573cac.svg";